import { render, staticRenderFns } from "./signer-details-form.vue?vue&type=template&id=657811c9&"
import script from "./signer-details-form.vue?vue&type=script&lang=js&"
export * from "./signer-details-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "signer-details-form.vue"
export default component.exports